<template>
  <div id="app">
    <HtmlPage />
  </div>
</template>

<script>
import HtmlPage from './components/HtmlPage.vue'

export default {
  name: 'App',
  components: {
    HtmlPage,
  },
}
</script>

<style>
@import './assets/layout.css';
</style>
